import React, { Component } from "react";
import { connect } from "react-redux";
import Preloader from "../../components/Preloader";
import HeaderAdmin from "../../components/HeaderAdmin";
import SidebarSuperAdmin from "../../components/admin/Sidebaar";
import FooterAdmin from "../../components/FooterAdmin";
import { Form, Formik, Field, ErrorMessage } from "formik";
import { setUserData } from "../../redux-store/action";
import { authenticationService } from "../../_services";
import { departmentService, subDepartmentService } from "../../_services/admin";
import Select from "react-select";
import { Link } from "react-router-dom";
import swal from "sweetalert";

import * as Yup from "yup";

function mapStateToProps(state) {
  return {};
}

function mapDispatchToProps(dispatch) {
  return {
    setUserData: (data) => {
      dispatch(setUserData(data));
    },
  };
}

function validateEmail(value) {
  let error;
  if (!value) {
    error = "Required";
  } else if (!/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(value)) {
    error = "Invalid email address";
  }
  return error;
}

class CreateSubDepartment extends Component {
  constructor(props) {
    super(props);

    this.state = {
      currentUser: authenticationService.currentUserValue,
      subdepartment: {},
      departmentList: [],
      loading: true,
      staffOptions: [],
    };
  }
  componentDidMount() {
    this.getAllDepartments();
    //this.getAllUsers()
    this.props.setUserData(this.state.currentUser);
    this.props.match.params.id &&
      subDepartmentService
        .getSubDepartmentById(this.props.match.params.id)
        .then((data) => {
          this.setState({ subdepartment: data.Data, loading: false });
        });
    this.setState({ loading: false });
  }
  getAllDepartments() {
    departmentService
      .getAll()
      .then((data) => this.setState({ departmentList: data.Data }));
  }

  render() {
    const departments = this.state.departmentList;
    const departmentList = departments.map((department, index) => (
      <option key={index} value={department._id}>
        {department.name}
      </option>
    ));
    return (
      <div id="main-wrapper" className="fix-header fix-sidebar card-no-border">
        {this.state.loading && <Preloader />}
        <HeaderAdmin />
        <SidebarSuperAdmin />
        <div className="page-wrapper">
          <div className="container-fluid">
            <div className="row page-titles">
              <div className="col-md-5 col-8 align-self-center">
                <h3 className="text-themecolor m-b-0 m-t-0">
                  {!this.state.subdepartment._id
                    ? "Create Sub Department"
                    : "Edit Sub Department"}
                </h3>
                <ol className="breadcrumb">
                  <li className="breadcrumb-item">
                    <a href="/">Home</a>
                  </li>
                  <li className="breadcrumb-item active">
                    Create Sub Department
                  </li>
                </ol>
              </div>
            </div>
            <div className="row">
              <div className="col-md-6">
                <div className="pt-4">
                  <div className="card">
                    <Formik
                      enableReinitialize={true}
                      initialValues={{
                        subDepartmentId: this.state.subdepartment._id || null,
                        departmentId:
                          this.state.subdepartment.departmentId || "",
                        name: this.state.subdepartment.name || "",
                        description: this.state.subdepartment.description || "",
                        currentUserId: this.state.currentUser.id,
                        isActive: this.state.subdepartment.isActive || "",
                        // staffsForReferal:this.state.department?this.state.department.staffsForReferal : []
                      }}
                      validationSchema={Yup.object().shape({
                        departmentId: Yup.string().required(
                          "Department is required"
                        ),
                        name: Yup.string().required(
                          "Department Name is required"
                        ),
                        description: Yup.string().required(
                          "Description is required"
                        ),
                      })}
                      onSubmit={(formData, { setStatus, setSubmitting }) => {
                        setStatus();
                        console.log("formData: ", formData);
                        subDepartmentService.create(formData).then(
                          (user) => {
                            //const { prevPath } = this.props.location.state || { prevPath: { pathname: "/admin/departments" } };
                            this.props.history.goBack();
                            swal(
                              "Sub Department Added Succesfully!",
                              "",
                              "success"
                            );
                          },
                          (error) => {
                            setSubmitting(false);
                            setStatus(error);
                          }
                        );
                      }}
                      render={({
                        errors,
                        status,
                        touched,
                        isSubmitting,
                        values,
                        setFieldValue,
                      }) => (
                        <Form>
                          <div className="card-body">
                            <div className="row form-material">
                              <div className="col-md-12">
                                <div className="form-group required">
                                  <label className="control-label d-inline-block w-100">
                                    Department
                                  </label>
                                  <Field
                                    name="departmentId"
                                    as="select"
                                    className={
                                      "form-control" +
                                      (errors.departmentId &&
                                      touched.departmentId
                                        ? " is-invalid"
                                        : "")
                                    }
                                    placeholder="Select Department"
                                  >
                                    <option value="">Select Department</option>
                                    {departmentList}
                                  </Field>
                                  <ErrorMessage
                                    name="departmentId"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="form-group required">
                                  <label className="control-label">
                                    Sub Department Name
                                  </label>
                                  <Field
                                    name="name"
                                    type="text"
                                    placeholder="Sub Department Name"
                                    className={
                                      "form-control" +
                                      (errors.name && touched.name
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name="name"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                                <div className="form-group required">
                                  <label className="control-label">
                                    Description
                                  </label>
                                  <Field
                                    name="description"
                                    type="text"
                                    placeholder="Description"
                                    className={
                                      "form-control" +
                                      (errors.description && touched.description
                                        ? " is-invalid"
                                        : "")
                                    }
                                  />
                                  <ErrorMessage
                                    name="description"
                                    component="div"
                                    className="invalid-feedback"
                                  />
                                </div>
                                {/* <div className="form-group">
                                                    <label htmlFor="" className="control-label">Staff For Refral</label>
                                                    <Field name="staffForReferal" type="text" autoComplete="off" 
                                                        placeholder="Staff" 
                                                        className={'forminput' + (errors.recipient && touched.staffsForReferal ? ' is-invalid' : '')}
                                                            render={({field})=> (
                                                                <Select
                                                                    isMulti
                                                                    isSearchable
                                                                    onChange={(data)=>{
                                                                        console.log( data && data.map(elem=>elem.value));
                                                                        setFieldValue('staffsForReferal',data ?data.map(elem=>elem.value):[]);
                                                                    }}
                                                                    className={' ' + (errors.staffsForReferal && touched.staffsForReferal ? ' is-invalid' : '')}
                                                                    options={
                                                                        
                                                                        this.state.staffOptions?.map(opt=>({
                                                                            label:opt.name,
                                                                            value:opt.value
                                                                        }))
                                                                    }
                                                                    value={this.state.staffOptions?.filter(elem=>(values?.staffsForReferal?.includes(elem.value)))?.map(opt=>({
                                                                        label:opt.name,
                                                                        value:opt.value
                                                                    }))}
                                                                    placeholder="Choose Staff" />
                                                            )}
                                                        />
                                                </div> */}
                              </div>
                            </div>
                          </div>
                          <div className="card-footer accordionfooter d-flex">
                            <div style={{ marginRight: "5px" }}>
                              <Link
                                to="/admin/departments"
                                className="btn btn-secondary"
                                style={{
                                  backgroundColor: "grey",
                                  color: "white",
                                }}
                              >
                                {/* <i className="mdi mdi-chevron-left"></i> */}
                                <span className="hide-menu">Cancel</span>
                              </Link>
                            </div>
                            <button
                              type="submit"
                              disabled={isSubmitting}
                              className="btn btn-primary"
                            >
                              {" "}
                              {!this.state.subdepartment._id
                                ? "Save Sub Department"
                                : "Update Sub Department"}{" "}
                            </button>

                            {isSubmitting && (
                              <img src="data:image/gif;base64,R0lGODlhEAAQAPIAAP///wAAAMLCwkJCQgAAAGJiYoKCgpKSkiH/C05FVFNDQVBFMi4wAwEAAAAh/hpDcmVhdGVkIHdpdGggYWpheGxvYWQuaW5mbwAh+QQJCgAAACwAAAAAEAAQAAADMwi63P4wyklrE2MIOggZnAdOmGYJRbExwroUmcG2LmDEwnHQLVsYOd2mBzkYDAdKa+dIAAAh+QQJCgAAACwAAAAAEAAQAAADNAi63P5OjCEgG4QMu7DmikRxQlFUYDEZIGBMRVsaqHwctXXf7WEYB4Ag1xjihkMZsiUkKhIAIfkECQoAAAAsAAAAABAAEAAAAzYIujIjK8pByJDMlFYvBoVjHA70GU7xSUJhmKtwHPAKzLO9HMaoKwJZ7Rf8AYPDDzKpZBqfvwQAIfkECQoAAAAsAAAAABAAEAAAAzMIumIlK8oyhpHsnFZfhYumCYUhDAQxRIdhHBGqRoKw0R8DYlJd8z0fMDgsGo/IpHI5TAAAIfkECQoAAAAsAAAAABAAEAAAAzIIunInK0rnZBTwGPNMgQwmdsNgXGJUlIWEuR5oWUIpz8pAEAMe6TwfwyYsGo/IpFKSAAAh+QQJCgAAACwAAAAAEAAQAAADMwi6IMKQORfjdOe82p4wGccc4CEuQradylesojEMBgsUc2G7sDX3lQGBMLAJibufbSlKAAAh+QQJCgAAACwAAAAAEAAQAAADMgi63P7wCRHZnFVdmgHu2nFwlWCI3WGc3TSWhUFGxTAUkGCbtgENBMJAEJsxgMLWzpEAACH5BAkKAAAALAAAAAAQABAAAAMyCLrc/jDKSatlQtScKdceCAjDII7HcQ4EMTCpyrCuUBjCYRgHVtqlAiB1YhiCnlsRkAAAOwAAAAAAAAAAAA==" />
                            )}
                          </div>
                          {status && (
                            <div className={"alert alert-danger"}>{status}</div>
                          )}
                        </Form>
                      )}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <FooterAdmin />
        </div>
      </div>
    );
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(CreateSubDepartment);
